<template>
    <div>
        <div class="md:hidden">
            <font-awesome-icon
                icon="search"
                class="text-neutral-dark text-lg cursor-pointer"
                @click="toggleMobileSearch"
            />

            <div v-if="showMobileSearch" class="super-search bg-white absolute flex z-20 pin-l w-full shadow p-lg mt-xl">
                <input
                    v-model="query"
                    type="text"
                    placeholder="Sök"
                    autocomplete="off"
                    @keydown.down="down"
                    @keydown.up="up"
                    @keydown.enter="hit"
                    @keydown.esc="reset"
                    @input="update"
                >

                <span v-if="loading" class="absolute">
                    <font-awesome-icon
                        icon="spinner"
                        spin
                        pulse
                    />
                </span>
                <template v-else>
                    <span v-show="isEmpty" class="absolute">
                        <font-awesome-icon icon="search" class="text-neutral-dark" />
                    </span>
                    <span
                        v-show="isDirty"
                        class="absolute"
                        @click="reset"
                    >
                        <font-awesome-icon icon="times" />
                    </span>
                </template>

                <div v-if="canSearchLegacyInfo" class="checkbox-container">
                    <checkbox-input v-model="searchLegacyInfo">
                        Sök i Dynamics-data
                    </checkbox-input>
                </div>

                <ul v-show="hasItems">
                    <li
                        v-for="(item, index) in items"
                        :class="activeClass(index)"
                        @mousedown="hit"
                        @mousemove="setActive(index)"
                    >
                        <span class="title" v-text="item.title" />
                        <span
                            v-if="item.subtitle"
                            class="subtitle"
                            v-text="item.subtitle"
                        />
                    </li>
                    <li
                        class="show-all-results text-center hover:bg-accent-clay-orange-dark"
                        @mousedown="redirectToAllSearchResults"
                        @mousemove="setActive(-1)"
                    >
                        <a
                            :href="searchResultsPageUrl"
                            class="hover:text-white block rounded-b-xl"
                        >
                            Visa alla sökresultat
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="hidden md:block">
            <div v-click-outside="reset" class="super-search w-full">
                <div class="super-search-content relative">
                    <input
                        v-model="query"
                        type="text"
                        placeholder="Sök"
                        autocomplete="off"
                        @keydown.down="down"
                        @keydown.up="up"
                        @keydown.enter="hit"
                        @keydown.esc="reset"
                        @input="update"
                    >

                    <span v-if="loading" class="icon-container">
                        <font-awesome-icon
                            icon="spinner"
                            class="text-xs"
                            spin
                            pulse
                        />
                    </span>
                    <template v-else>
                        <span
                            v-show="isEmpty"
                            class="icon-container"
                        >
                            <font-awesome-icon icon="search" class="text-xs text-neutral-dark" />
                        </span>
                        <span
                            v-show="isDirty"
                            class="icon-container"
                            @click="reset"
                        >
                            <font-awesome-icon icon="times" class="text-xs" />
                        </span>
                    </template>
                    <div v-if="canSearchLegacyInfo" class="checkbox-container">
                        <checkbox-input v-model="searchLegacyInfo">
                            Sök i Dynamics-data
                        </checkbox-input>
                    </div>

                    <ul v-show="hasItems && ! errorStatus">
                        <li>
                            Sökresultat för &ldquo;<span class="font-bold">{{ previousQuery }}</span>&ldquo;:
                        </li>
                        <li
                            v-for="(item, index) in items"
                            :class="activeClass(index)"
                            @mousedown="hit"
                            @mousemove="setActive(index)"
                        >
                            <span class="title" v-text="item.title" />
                            <span
                                v-if="item.subtitle"
                                class="subtitle"
                                v-text="item.subtitle"
                            />
                        </li>
                        <li
                            class="show-all-results text-center hover:bg-accent-clay-orange-dark"
                            @mousedown="redirectToAllSearchResults"
                            @mousemove="setActive(-1)"
                        >
                            <a
                                :href="searchResultsPageUrl"
                                class="hover:text-white block rounded-b-xl"
                            >
                                Visa alla sökresultat
                            </a>
                        </li>
                    </ul>
                    <div v-if="errorStatus" class="mt-sm p-lg bg-white shadow absolute z-10">
                        <span v-if="errorStatus === 429">
                            Det verkar som att du sökt lite för mycket, om du väntar en minut
                            bör du kunna söka igen.
                        </span>
                        <span v-else>
                            Någonting gick fel, försök igen lite senare.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueTypeahead from '../../../../../shared/components/VueTypeahead.vue';
    import ClickOutside from 'vue-click-outside';

    export default {

        directives: {
            ClickOutside,
        },
        extends: VueTypeahead,

        props: {
            src: {
                type: String,
                required: true,
            },
            canSearchLegacyInfo: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                limit: 20,
                minChars: 2,
                selectFirst: true,
                loading: false,
                showMobileSearch: false,
                hasShowAllResults: true,
                searchLegacyInfo: false,
            };
        },
        computed: {
            searchResultsPageUrl() {
                return route('admin.search-results.index', {
                    query: this.previousQuery || this.query,
                    searchLegacyInfo: this.searchLegacyInfo ? 1 : 0,
                });
            },
        },
        methods: {
            onHit(item) {
                if (item) {
                    window.location = item.url;
                }
            },
            redirectToAllSearchResults() {
                window.location = this.searchResultsPageUrl;
            },
            toggleMobileSearch() {
                this.showMobileSearch = ! this.showMobileSearch;
            },
        },
    };
</script>
